import React from 'react';

interface GalleryCardProps {
    mediaUrl: string;
    handleClick: () => void;
    isVideo: boolean;
}

const GalleryCard: React.FC<GalleryCardProps> = ({ mediaUrl, handleClick, isVideo }) => {

    return (
        <div className="col-lg-2 col-md-4 col-6 d-flex align-items-stretch my-2">
            <div className="card d-flex flex-column" style={{ width: '100%', height: '100%', cursor: 'pointer' }} onClick={handleClick}>
                <div className="card-body d-flex flex-column justify-content-center">
                    <div>
                        {isVideo ? (
                            <div className="video-thumbnail">
                                <video src={mediaUrl} muted className="img-fluid gallery-thumbnail" />
                                <span className="play-icon">▶</span>
                            </div>
                        ) : (
                            <img
                                src={mediaUrl}
                                className="img-fluid gallery-thumbnail rounded"
                                alt="Gallery thumbnail"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GalleryCard;
